import type { IntlKey } from 'locales';
import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import type { CellProps } from './CheckBoxCell';

type TextCellProps = CellProps<string> & {
  placeholderKey: IntlKey;
};

export const TextFieldCell: FC<TextCellProps> = ({ value, onValueChange, id, isReadOnly, placeholderKey }) => {
  const { formatMessage } = useIntl();
  const [current, setCurrent] = useState<string>(value);
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setCurrent(e.target.value), []);
  const onBlur = useCallback(() => {
    if (current !== value) {
      onValueChange(current);
    }
  }, [current, value, onValueChange]);

  useEffect(() => {
    setCurrent(value);
  }, [value]);

  return (
    <input
      className="form-control"
      data-e2e={id + '-input'}
      disabled={isReadOnly}
      id={id}
      onBlur={onBlur}
      onChange={onChange}
      type="text"
      value={current}
      placeholder={!isReadOnly ? formatMessage({ id: placeholderKey }) : undefined}
    />
  );
};

TextFieldCell.displayName = 'TextFieldCell';
